/**
 * Interactions for the [open] vis record landing page.
 *
 * This code is served from the instance's own Webpack bundle so it remains
 * compatible with the site's Content Security Policy (which blocks inline
 * scripts).
 */

import "./comments.js";
// Trial of a non-Semantic-UI visual system (Tailwind utilities + the
// shadcn/ui Card/Button recipes) on the badge sidebar panel only - see
// assets/tailwind/README.md for how this file is generated and why it's
// a separate, standalone compile step rather than part of this bundle's
// own LESS/CSS rule.
import "../../less/open_vis_framework/tailwind.generated.css";

const badgePanel = document.getElementById("ovf-embed-badge");

if (badgePanel) {
  const status = badgePanel.querySelector(".ovf-badge-copy-status");

  badgePanel.querySelectorAll(".ovf-copy-badge").forEach((button) => {
    button.addEventListener("click", async () => {
      const field = document.getElementById(button.dataset.copyTarget);
      if (!field) return;

      let copied = false;
      try {
        if (!navigator.clipboard?.writeText) {
          throw new Error("Clipboard API unavailable");
        }
        await navigator.clipboard.writeText(field.value);
        copied = true;
      } catch {
        field.focus();
        field.select();
        try {
          copied = document.execCommand("copy");
        } catch {
          copied = false;
        }
      }

      if (!copied) {
        if (status) {
          status.textContent = "Copy failed. Select and copy the text manually.";
        }
        return;
      }

      if (status) status.textContent = "Embed code copied.";
      button.textContent = "Copied";
      window.setTimeout(() => {
        button.textContent = "Copy";
        if (status) status.textContent = "";
      }, 1800);
    });
  });
}


const contextButton = document.querySelector(".ovf-copy-context");
if (contextButton) {
  contextButton.addEventListener("click", async () => {
    const status = document.querySelector(".ovf-context-copy-status");
    try {
      await navigator.clipboard.writeText(contextButton.dataset.contextUrl);
      status.textContent = "Link copied.";
    } catch {
      status.textContent = "Copy this link: " + contextButton.dataset.contextUrl;
    }
  });
}

const entryCopyButton = document.querySelector(".ovf-copy-entry");
if (entryCopyButton) {
  entryCopyButton.addEventListener("click", async () => {
    const field = document.getElementById("ovf-voi-link");
    const status = document.querySelector(".ovf-voi-copy-status");
    if (!field || !status) return;
    let copied = false;
    try {
      await navigator.clipboard.writeText(field.value);
      copied = true;
    } catch {
      field.hidden = false;
      field.focus();
      field.select();
      try { copied = document.execCommand("copy"); } catch { copied = false; }
    }
    if (copied) {
      field.hidden = true;
      entryCopyButton.focus();
    }
    status.textContent = copied ? "Entry link copied." : "Select and copy the link manually.";
  });
}
